<template>
  <v-container fluid grid-list-md>
    <v-layout wrap>
      <v-flex xs12>
        <h4 class="mb-3">Информация</h4>
        <p>
          <a :href="`${publicPath}static/SAD_230101_1111111111111_01.dbf`" download>Шаблон реестра</a>
        </p>
        <p>
          Имя файла имеет вид: SAD_ГГММДД_ОГРН_ПП.тип,<br>
          где:<br>
          SAD – префикс файл;<br>
          ГГММДД – дата формирования файла (год, месяц, день);<br>
          ОГРН – ОГРН организации осуществляющей загрузку;<br>
          ПП – порядковый номер реестра за день;<br>
          Тип – dbf.<br>
          Пример: SAD_230315_1023802658142_01.dbf
        </p>
      </v-flex>
      <router-view></router-view>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    publicPath () {
      return process.env.BASE_URL
    }
  },
  created: function () {
    this.$store.dispatch('reportingReport/fetchTypes')
  }
}
</script>
<style>

</style>
